export default "__VITE_ASSET__DxDEg_Tg__"